import {
  CLEAR_SELFIES_ERROR,
  REMOVE_SELFIE_REQUEST,
  SAVE_SELFIES_FAILURE,
  SAVE_SELFIES_REQUEST,
  SAVE_SELFIES_SUCCESS,
  SET_SELFIE_REQUEST,
} from 'dux/selfies/actions';

const initialState = {
  selfies: [],
  isLoading: false,
  error: null,
  saved: false,
};

export default function selfiesReducer(state = initialState, action) {
  switch (action.type) {
    case SET_SELFIE_REQUEST: {
      const newSelfie = { filename: action.filename, content: action.file };
      return {
        selfies: state.selfies.concat(newSelfie),
      };
    }
    case REMOVE_SELFIE_REQUEST: {
      const newState = state.selfies;
      const filterState = newState.filter(selfie => selfie.filename !== action.filename);
      return {
        ...state,
        selfies: filterState,
      };
    }
    case SAVE_SELFIES_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: false,
      };

    case SAVE_SELFIES_SUCCESS:
      return {
        ...state,
        isLoading: false,
        error: false,
        saved: true,
      };

    case SAVE_SELFIES_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: true,
      };

    case CLEAR_SELFIES_ERROR:
      return {
        ...state,
        error: false,
      };

    default:
      return state;
  }
}
